import InputBase from '@material-ui/core/InputBase';
import { createStyles, withStyles, Theme, makeStyles, styled } from '@material-ui/core/styles';
import { colors } from '../../theme/colors';
import { INPUT_HEIGHT } from '../../theme/constants';
import { compose, sizing, spacing } from '@material-ui/system';
import { TextField } from '@material-ui/core';

const CustomInput = withStyles((theme: Theme) =>
	createStyles({
		root: {
			'label + &': {
				marginTop: theme.spacing(1),
			},
			'& .MuiInputAdornment-positionEnd': {
				marginLeft: 0,
				// border: `1px solid ${theme.palette.secondary.main}`,
				minHeight: INPUT_HEIGHT,
			},
		},
		input: {
			height: INPUT_HEIGHT,
			position: 'relative',
			backgroundColor: theme.palette.common.white,
			boxSizing: 'border-box',
			outlineWidth: 1,
			outlineStyle: 'solid',
			outlineColor: colors['silver-grey'],
			fontSize: 16,
			padding: '14px',
			'&:hover': {
				outlineColor: theme.palette.common.black,
			},
			'&:focus': {
				outlineStyle: 'solid',
				outlineColor: theme.palette.common.black,
				outlineWidth: 1,
			},
			'&:disabled': {
				outlineColor: colors['silver-grey'],
			},
		},
	}),
)(InputBase);

export const CustomTextField = withStyles((theme: Theme) =>
	createStyles({
		root: {
			'label + &': {
				marginTop: theme.spacing(1),
			},
			'& .MuiInputAdornment-positionEnd': {
				marginLeft: 0,
				// border: `1px solid ${theme.palette.secondary.main}`,
				minHeight: INPUT_HEIGHT,
			},
		},
	}),
)(TextField);

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
			flexWrap: 'wrap',
			minHeight: 72,
			justifyContent: 'flex-end',
			marginLeft: 0,
			marginRight: 0,
		},
		label: {
			whiteSpace: 'nowrap',
		},
	}),
);

export default styled(CustomInput)(compose(sizing, spacing));
